import { I18N_PLATFORM_COMMON_WORD_PATH } from 'constants/i18n';
import { SearchOperations } from 'constants/searchOperations';
import { translateText } from 'utils/i18n';

export enum CompanyFieldsNames {
  DOMAIN = 'domain',
  HEADQUARTER_PROPERTY = 'headquarterProperty',
  HEADQUARTERS = 'headquarters',
  INDUSTRY = 'industry',
  INVESTOR = 'investorType',
  NAME = 'name',
  OPERATING_NAME = 'operatingName',
  LEGAL_NAME = 'legalName',
  STOCK_CODE = 'stockCode',
  WEBSITE = 'website',
  LINKEDIN = 'linkedIn',
  PARENT_COMPANY_ID = 'parentCompanyId',
  PARENT_COMPANY = 'parentCompany',
  NAICS = 'naics',
  NAICS_ID = 'naicsId',
}

export const NOTIFICATION_MESSAGES = {
  DEFAULT: translateText(
    `${I18N_PLATFORM_COMMON_WORD_PATH}.companyCouldntCreated`,
  ),
  SUCCESS: (companyName: string) =>
    `${translateText(`${I18N_PLATFORM_COMMON_WORD_PATH}.companyCreated`, {
      companyName: companyName,
    })}`,
  ERROR: (companyName: string) =>
    `${translateText(
      `${I18N_PLATFORM_COMMON_WORD_PATH}.givenCompanyCouldntCreated`,
      {
        companyName: companyName,
      },
    )}`,
};

export const NOTIFICATION_INIT = {
  isVisible: false,
  hasError: false,
  message: '',
};

export const COMPANY_FIELDS_INIT = {
  domain: undefined,
  headquarterProperty: undefined,
  headquarters: undefined,
  comments: undefined,
  industry: undefined,
  name: undefined,
  stockCode: undefined,
  website: undefined,
  linkedIn: undefined,
  investorType: undefined,
};

export const INDUSTRY_FIELD_VARIABLES = {
  search: {
    fields: {
      or: [
        {
          key: 'approved',
          op: SearchOperations.eq,
          value: 'true',
        },
      ],
    },
  },
};
